export default __webpack_public_path__ + "static/media/outcess12.b5b79e60.jpeg";